const JWT_PATTERN = /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/;

export const normalizeAuthToken = (value) => {
  if (typeof value !== "string") return null;

  const token = value.trim().replace(/^Bearer\s+/i, "");
  return JWT_PATTERN.test(token) ? token : null;
};

export const getStoredAuthToken = () => {
  const storedToken = localStorage.getItem("token");
  const token = normalizeAuthToken(storedToken);

  if (storedToken && !token) {
    localStorage.removeItem("token");
    localStorage.removeItem("helpclic_web_push_token");
  }

  return token;
};

